import { useEffect } from 'react'

import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { Request } from 'commons/utils/request/request'
import { LicenseEdit } from '~bank-licenses/types'

export const useGetLicense = (opts: { licenseId: number; companyId: number }) => {
  const {
    data: license,
    isFetching,
    error
  } = useQuery<{ licenseId: number; companyId: number }, Error, LicenseEdit>({
    queryKey: ['license-form', opts],
    queryFn: () =>
      opts.licenseId
        ? Request.getVirtual(Request.urls.bank.licenseEdit, opts)
        : Request.getVirtual(Request.urls.bank.licenseCreate, { companyId: opts.companyId }),
    staleTime: 1000,
    placeholderData: keepPreviousData
  })

  useEffect(() => {
    if (error) {
      throw error
    }
  }, [error])

  const data = opts.licenseId
    ? license
    : {
        licenseSubtypeOptions: [],
        licenseTypeOptions: [],
        licensePOSTypeOptions: [],
        form: {
          active: true,
          city: '',
          cityTax: '',
          companyId: opts.companyId,
          countyTax: '',
          id: 0,
          issueDate: null,
          nullificationDate: null,
          licenseNumber: '',
          mjRetailTax: '',
          name: '',
          phone: '',
          posType: '',
          posTypeOther: '',
          postalCode: '',
          specialTax: '',
          state: '',
          stateTax: '',
          streetAddress: '',
          subtype: '',
          type: '',
          internalNotes: ''
        },
        companyName: '',
        ...license
      }

  return {
    data,
    isFetching
  }
}
